// @ts-nocheck
import AppTemplate from "classes/AppTemplate/AppTemplate";
import genRequest from "includes/request";

class SiteObject {
	#address = null;
	#town = null;
	#appTemplateId = null;
	#companyId = null;
	#country = "";
	#lastChanged = null;
	#lastChangeAuthorId = null;
	#languageId = 1;
	#localisation = "";
	#mailAddress = null;
	#siteName = "";
	#phoneNumber = null;
	#postalCode = null;
	#id = null;
	#website = null;

	#logo = null;
	#oldLogo = null;
	#adminId = null;
	#template = false;
	#duplicatePosts = false;

	constructor(props) {
		this.#address = props?.address;
		this.#town = props?.town;
		this.#appTemplateId = props?.appTemplateId;
		this.#companyId = props?.companyId;
		this.#country = props?.country;
		this.#lastChanged = Date.now();
		this.#lastChangeAuthorId = props?.lastChangeAuthorId;
		this.#languageId = props?.languageId || 1;
		this.#localisation = props?.localisation;
		// The API returns the v2 entity fields (name, mail, phone).
		this.#mailAddress = props?.mail ?? props?.mailAddress;
		this.#siteName = props?.name ?? props?.siteName;
		this.#phoneNumber = props?.phone ?? props?.phoneNumber;
		this.#postalCode = props?.postalCode;
		this.#id = props?.id;
		this.#website = props?.website;

		if (props.template) this.#template = props.template;
		else if (this.#id && this.#appTemplateId)
			this.#template = new AppTemplate(this.#appTemplateId);
		this.#duplicatePosts = props.duplicatePosts || false;
	}

	fetchTemplate = () => this.#template.fetch();

	send() {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			that.#template.adminSiteId(this.#adminId);
			let xhr = that.#template
				.send()
				.then((resp) => {
					that.#appTemplateId = resp;
					return that.sendSite();
				}, reject)
				.then((resp) => {
					resolve(resp);
				}, reject);
			return xhr;
		});
		return prom;
	}

	sendSite() {
		let that = this;

		let url = "sites" + (this.#id ? "/" + this.#id : "");
		if (this.#duplicatePosts)
			url = "sites/post-site-with-all-sites-published-news";
		let xhr = genRequest(
			url,
			this.values(),
			this.#id ? "put" : "post"
		).then((resp) => {
			if (!that.#id) {
				that.#id = resp.id;
				if (that.#duplicatePosts) that.#id = resp.site?.id;
				that.#duplicatePosts = false;
			}
			return resp;
		});
		return xhr;
	}

	sendLogo() {
		if (!this.#logo) return Promise.resolve();

		this.#logo.resetLinks(this.#companyId, this.#id);

		return this.#logo.send();
	}

	deleteLogo(documentId) {
		let xhr = genRequest(
			"documents/" + documentId,
			null,
			"delete"
		);
		return xhr;
	}

	logo(setLogo, onlyOld) {
		if (typeof setLogo !== "undefined") {
			if (!this.#oldLogo)
				this.#oldLogo = this.#logo ? this.#logo : setLogo;
			if (!onlyOld) this.#logo = setLogo;
		}
		return this.#logo;
	}

	adminId(setAdminId) {
		if (typeof setAdminId !== "undefined") this.#adminId = setAdminId;
		return this.#adminId;
	}
	adress(setAdress) {
		if (typeof setAdress !== "undefined") this.#address = setAdress;
		return this.#address;
	}

	appTemplateId(setAppTemplateId) {
		if (typeof setAppTemplateId !== "undefined")
			this.#appTemplateId = setAppTemplateId;
		return this.#appTemplateId;
	}

	companyId(setCompanyId) {
		if (typeof setCompanyId !== "undefined") this.#companyId = setCompanyId;
		return this.#companyId;
	}

	country(setCountry) {
		if (typeof setCountry !== "undefined") this.#country = setCountry;
		return this.#country;
	}

	lastChanged(setLastChanged) {
		if (typeof setLastChanged !== "undefined")
			this.#lastChanged = setLastChanged;
		return this.#lastChanged;
	}

	languageId(setLanguageId) {
		if (typeof setLanguageId !== "undefined")
			this.#languageId = setLanguageId;
		return this.#languageId;
	}

	localisation(setLocalisation) {
		if (typeof setLocalisation !== "undefined")
			this.#localisation = setLocalisation;
		return this.#localisation;
	}

	mail(setMail) {
		if (typeof setMail !== "undefined") this.#mailAddress = setMail;
		return this.#mailAddress;
	}

	name(setName) {
		if (typeof setName !== "undefined") this.#siteName = setName;
		return this.#siteName;
	}

	phone(setPhone) {
		if (typeof setPhone !== "undefined") this.#phoneNumber = setPhone;
		return this.#phoneNumber;
	}

	postalCode(setPostalCode) {
		if (typeof setPostalCode !== "undefined")
			this.#postalCode = setPostalCode;
		return this.#postalCode;
	}

	siteId(setSiteId) {
		if (typeof setSiteId !== "undefined") this.#id = setSiteId;
		return this.#id;
	}

	town(setTown) {
		if (typeof setTown !== "undefined") this.#town = setTown;
		return this.#town;
	}

	website(setWebsite) {
		if (typeof setWebsite !== "undefined") this.#website = setWebsite;
		return this.#website;
	}

	duplicate(setDuplicate) {
		if (typeof setDuplicate !== "undefined")
			this.#duplicatePosts = setDuplicate;
		return this.#duplicatePosts;
	}

	template(setTemplate) {
		if (setTemplate) this.#template = setTemplate;
		return this.#template;
	}

	values() {
		return {
			address: this.#address,
			town: this.#town,
			siteName: this.#siteName,
			appTemplateId: this.#appTemplateId,
			companyId: this.#companyId,
			country: this.#country,
			languageId: this.#languageId,
			localisation: this.#localisation,
			mail: this.#mailAddress,
			name: this.#siteName,
			phone: this.#phoneNumber,
			postalCode: this.#postalCode,
			website: this.#website,
		};
	}
}

export default SiteObject;
